import type { Address } from '@vsf-enterprise/commercetools-types';

const setVatNumberToAddress = (address: Partial<Address>, vatNumber: string): void => {
  address.fax = vatNumber;
};

export default setVatNumberToAddress;
